import React from 'react'
import type { Icon } from 'shared/utils'

const RestrictionSign = (props: Icon) => {
    const {
        color = '#BB1E32',
        size = 24,
        className = 'restriction-sign',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M6.658 8.708a6.242 6.242 0 001.107 7.932c2.297 2.098 5.537 2.022 7.51.686L6.658 8.708zm1.943-1.98l8.668 8.672c1.487-2.14 1.468-5.544-.802-7.832-2.27-2.287-5.692-2.341-7.866-.84zM12.02 3a9 9 0 11-.042 18 9 9 0 01.042-18z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    )
}

export { RestrictionSign }
